import React, { useState, useEffect } from 'react'
import '../zodiac/zodiac.css'
import getHoroscope from '../../hooks/getHoroscope'
import countVisitors from '../../hooks/countVisitors'
import getAds from '../../hooks/getAds'

import red from '../../assets/red.png'
import maroon from '../../assets/maroon.png'
import yellow from '../../assets/yellow.png'
import orange from '../../assets/orange.png'
import lightGreen from '../../assets/lightGreen.png'
import green from '../../assets/green.png'
import aqua from '../../assets/aqua.png'
import skyBlue from '../../assets/skyBlue.png'
import blue from '../../assets/blue.png'
import purple from '../../assets/purple.png'
import white from '../../assets/white.png'
import black from '../../assets/black.png'

const Color = ({ setAssetsLoading, windowSize, setLoading, setBackEvents, setResult, details, setDetails, colorState, setColorState, setResultState, setAds }) => {
    const [selectedColor, setSelectedColor] = useState('')

    // useEffect(() => {
    //     const colorCall = document.getElementById('colorCall')
    //     const pagesCall = document.getElementById('pagesCall')
        
    //     try {
    //         console.log('useeffect');
    //         colorCall.appendChild(pagesCall)
    //     } catch (error) {
    //         console.log(error);            
    //     }
    // }, [])

    const handleClick = ({color}) => {
        setDetails({...details, color: color})
        window.TiktokPixel(window, document, 'ttq');
        countVisitors({ page: 'spanish2-result' })
        
        getHoroscope({ setLoading: setLoading, setBackEvents: setBackEvents, setResult: setResult, zodiac: details.zodiac, color: color })
        getAds({ setAds: setAds })

        setColorState(e => {return {...e, animation: false, events: false}})
        setResultState(e => {return {...e, display: true}})
        
        setTimeout(() => {
            setColorState(e => {return {...e, display: false}})
            setResultState(e => {return {...e, animation: true}})
        }, 500);

        setTimeout(() => {
            setResultState(e => {return {...e, events: true}})
        }, 1500);
    }

    return (
        <div className="zodiacMain" style={{ display: (colorState.display) ? 'flex' : 'none', zIndex: (colorState.display) ? 10 : 0, pointerEvents: (colorState.events) ? 'all' : 'none', opacity: (colorState.animation) ? 1 : 0 }} >
            {/* <div id='colorCall'></div> */}
            
            <p id='actionText'>Escoge tu color favorito</p>

            <ul className="zodiacWheel" style={{ height: (colorState.animation) ? `${(windowSize.height > windowSize.width) ? (windowSize.width > 1000) ? 1000 : windowSize.width : (windowSize.height > 1000) ? 1000 : windowSize.height}px` : '10rem', width: (colorState.animation) ? `${(windowSize.height > windowSize.width) ? windowSize.width : windowSize.height}px` : '10rem', transform: (colorState.animation) ? 'rotate(360deg)' : 'rotate(0deg)'}}>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Rojo'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Rojo')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={red} alt="red" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, red: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, red: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Granate'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Granate')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={maroon} alt="maroon" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, maroon: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, maroon: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Amarillo'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Amarillo')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={yellow} alt="yellow" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, yellow: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, yellow: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Naranja'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Naranja')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={orange} alt="orange" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, orange: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, orange: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Verde Claro'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Verde Claro')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={lightGreen} alt="lightGreen" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, lightGreen: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, lightGreen: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Verde'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Verde')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={green} alt="green" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, green: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, green: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Aguamarina'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Aguamarina')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={aqua} alt="aqua" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, aqua: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, aqua: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Cielo Azul'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Cielo Azul')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={skyBlue} alt="skyBlue" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, skyBlue: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, skyBlue: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Azul'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Azul')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={blue} alt="blue" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, blue: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, blue: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Morado'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Morado')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={purple} alt="purple" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, purple: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, purple: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Blanco'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Blanco')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={white} alt="white" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, white: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, white: false}})}} />
                        </div>
                    </div>
                </li>
                <li className="zodiac">
                    <div className="zodiac-contents" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div onClick={() => handleClick({color: 'Negro'})} style={{ opacity: 1 }} onMouseOver={() => setSelectedColor('Negro')} onMouseLeave={() => setSelectedColor('')}>
                            <img src={black} alt="black" style={{ height: '90%', width: '90%', borderRadius: '50%' }} onLoad={() => {setAssetsLoading(prev => {return {...prev, black: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, black: false}})}} />
                        </div>
                    </div>
                </li>
            </ul>

            <div style={{ top: 'calc(50% + 25px)' }}>
                <p>{selectedColor}</p>
            </div>
        </div>  
    )
}

export default Color